import replaceVariables, { type PhraseValues } from "./replaceVariables";
import type { CmsPhrase } from "./types";

// Resolves a CMS Phrase to a display string for a given brand — a matching
// brandOverwrite wins, then the default value, then the key — and substitutes
// any `{placeholder}` tokens with `values`. Substitution lives here (not just in
// CmsPhrase) so every caller gets it. Shared so improvements reach every app.
const resolvePhrase = (
  brandSlug: string,
  phrase?: CmsPhrase | null,
  values?: PhraseValues,
): string => {
  if (!phrase) {
    return "";
  }
  const overwrite = phrase.brandOverwrites?.find(
    (candidate) => candidate?.brand?.slug === brandSlug,
  );
  const resolved = overwrite?.value ?? phrase.value ?? phrase.key;
  return replaceVariables(resolved, values);
};

export default resolvePhrase;
